import gql from 'graphql-tag';

const fieldsBySection = {
  withSummaryAndLabel: `
    id
    summary
    labels
  `,
  withoutSummaryAndLabel: 'id',
};
const defaultFields = `
  id
  summary
  description
  labels
  creator {
    id
    name
  }
`;
const getFieldsBySection = (newsSection) => fieldsBySection[newsSection]
  || defaultFields;

export const getArticlesFields = (field, newsSection) => (
  field === 'newsArticles'
    ? `title
  imageUrls(configurations: $imageConfigurations)
  slug
  ${getFieldsBySection(newsSection)}
  createdAt
  featured
  category {
    id
    title
    path
  }` : `title
        imageUrls(configurations: $imageConfigurations)
        ${getFieldsBySection(newsSection)}
        createdAt
        featured
        slug
        path
        category {
          id
          title
          path
        }`);

const getArticlesQuery = (field, newsSection) => (field === 'newsArticles'
  ? gql`
    query getNewsArticles(
      $keywords: [String],
      $limit: Int,
      $offset: Int,
      $featured: Boolean,
      $notInIds: [Int],
      $sort: NewsArticleSorting,
      $inDays: Int,
      $inIds: [Int],
      $categoryIds: [Int],
      $inCreatedByIds: [Int],
      $newsboards: [Newsboard],
      $tagSlugs: [String],
      $statuses: [NewsArticleStatus],
      $imageConfigurations: [ResponsiveImageConfiguration]!,
    ) {
      newsArticles(
        keywords: $keywords
        limit: $limit
        offset: $offset
        featured: $featured
        notInIds: $notInIds
        sort: $sort
        inDays: $inDays
        inIds: $inIds
        categoryIds: $categoryIds
        inCreatedByIds: $inCreatedByIds
        newsboards: $newsboards
        tagSlugs: $tagSlugs
        statuses: $statuses
      ) {
        ${getArticlesFields(field, newsSection)}
      }
    }
  `
  : gql`
    query getNewsArticles(
      $keywords: [String],
      $limit: Int,
      $offset: Int,
      $featured: Boolean,
      $notInIds: [Int],
      $sort: NewsArticleSorting,
      $inDays: Int,
      $inIds: [Int],
      $categoryIds: [Int],
      $inCreatedByIds: [Int],
      $tagSlugs: [String],
      $statuses: [NewsArticleStatus],
      $imageConfigurations: [ResponsiveImageConfiguration]!,
    ) {
      ${field}(
        keywords: $keywords,
        limit: $limit,
        offset: $offset,
        featured: $featured,
        notInIds: $notInIds
        sort: $sort
        inDays: $inDays
        inIds: $inIds
        categoryIds: $categoryIds
        inCreatedByIds: $inCreatedByIds
        tagSlugs: $tagSlugs
        statuses: $statuses
      ) {
        ${getArticlesFields(field, newsSection)}
      }
    }
  `
);

export default getArticlesQuery;
